module.exports = __webpack_public_path__ + "media/application/images/company/founders/Alfred-Odell-0c42151b2d2493d1ae020d83451dbf4e.jpg";